import React, { useState } from "react";
import { Route, Routes } from "react-router-dom";
import Header from "../components/auth/header/Header";
import Sidebar from "../components/auth/sidebar/Sidebar";
import AdminAdd from "../pages/auth/admin/AdminAdd";
import AdminEdit from "../pages/auth/admin/AdminEdit";
import AdminList from "../pages/auth/admin/AdminList";
import AdminView from "../pages/auth/admin/AdminView";
import Dashboard from "../pages/auth/dashboard/Dashboard";
import InvitationAdd from "../pages/auth/invitation/InvitationAdd";
import InvitationList from "../pages/auth/invitation/InvitationList";
import Invitation from "../pages/unauth/invitation/Invitation";
import NoPage from "../pages/auth/NoPage/NoPage";
import InvitationEdit from "../pages/auth/invitation/InvitationEdit";
import ContactList from "../pages/auth/contact/ContactList";
import ContactView from "../pages/auth/contact/ContactView";
import EventAdd from "../pages/auth/event/EventAdd";
import EventList from "../pages/auth/event/EventList";
import EventEdit from "../pages/auth/event/EventEdit";
import ServiceAdd from "../pages/auth/service/ServiceAdd";
import ManageLinks from "../pages/auth/links/ManageLinks";
import ListTestimony from "../pages/auth/testimonial/ListTestimony";
import AddTestimony from "../pages/auth/testimonial/AddTestimony";
import EditTestimony from "../pages/auth/testimonial/EditTestimony";
import ProfileScreen from "../pages/auth/profile/ProfileScreen";
import GalleryUpdate from "../pages/auth/gallery/GalleryUpdate";
import ImageUpdate from "../pages/auth/image/ImageUpdate";
import Chatbot from "../pages/auth/chatbot/Chatbot";

export default function AuthLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  return (
    <div suppressHydrationWarning={true}>
      <div className="dark:bg-boxdark-2 dark:text-bodydark">
        <div className="flex h-screen overflow-hidden">
          <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
          <div className="relative flex flex-1 flex-col overflow-y-auto overflow-x-hidden">
            <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
            <div>
              <div className="mx-auto max-w-screen-2xl p-4 md:p-6 2xl:p-10">
                <Routes>
                  <Route path="/">
                    <Route index element={<Dashboard />} />

                    <Route path="dashboard" element={<Dashboard />} />

                    <Route path="admin">
                      <Route index element={<AdminList />} />
                      <Route path="add" element={<AdminAdd />} />
                      <Route path="update/:id" element={<AdminEdit />} />
                      <Route path="view/:id" element={<AdminView />} />
                    </Route>
                    <Route path="invitation">
                      <Route index element={<InvitationList />} />
                      <Route path="add" element={<InvitationAdd />} />
                      <Route path="update/:id" element={<InvitationEdit />} />
                      <Route path=":couple/:date" element={<Invitation />} />
                    </Route>
                    <Route path="event">
                      <Route index element={<EventList />} />
                      <Route path="add" element={<EventAdd />} />
                      <Route path="update/:id" element={<EventEdit />} />
                    </Route>
                    <Route path="testimony">
                      <Route index element={<ListTestimony />} />
                      <Route path="add" element={<AddTestimony />} />
                      <Route path="update/:id" element={<EditTestimony />} />
                    </Route>
                    <Route path="service">
                      <Route index element={<ServiceAdd />} />
                    </Route>
                    <Route path="gallery">
                      <Route index element={<GalleryUpdate />} />
                    </Route>
                    <Route path="image">
                      <Route index element={<ImageUpdate />} />
                    </Route>
                    <Route path="profile">
                      <Route index element={<ProfileScreen />} />
                    </Route>
                    <Route path="links">
                      <Route index element={<ManageLinks />} />
                    </Route>
                    <Route path="chatbot">
                      <Route index element={<Chatbot />} />
                    </Route>
                    <Route path="enquiry">
                      <Route index element={<ContactList />} />
                      <Route path="view/:id" element={<ContactView />} />
                    </Route>

                    <Route path="*" element={<NoPage />} />
                  </Route>
                </Routes>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
